module.exports = __webpack_public_path__ + "img/half2.3c52e2c.png";